export const REFERRER_OPTIONS = [
  'Colleague',
  'Google',
  'Facebook Ad',
  'Facebook Post',
  'Email',
  'Mail',
  'Clio',
  'Podcast',
  'Other',
];

// Only enforce unfilled welcome survey for orgs created on or after this date
export const WELCOME_SURVEY_ENFORCEMENT_DATE = new Date('2025-09-04T07:00:00Z'); // midnight PDT
